import type { RouteObject } from "react-router";

import { NotAvailableInMock } from "@/components/error/NotAvailableInMock";
import { ElectionCertificatePage } from "@/features/election_management/components/ElectionCertificatePage";
import { t } from "@/i18n/translate";
import { ElectionHomePage } from "./components/ElectionHomePage";
import { ElectionReportPage } from "./components/report/ElectionReportPage";
import { FinishDataEntryPage } from "./components/report/FinishDataEntryPage";
import { SubCommitteeKeysDetailPage } from "./components/sub_committee_keys/SubCommitteeKeysDetailPage";
import { SubCommitteeKeysOverviewPage } from "./components/sub_committee_keys/SubCommitteeKeysOverviewPage";
import { CommitteeSessionDetailsPage } from "./components/update/CommitteeSessionDetailsPage";
import { NumberOfVotersPage } from "./components/update/NumberOfVotersPage";

export const electionManagementRoutes: RouteObject[] = [
  {
    index: true,
    Component: ElectionHomePage,
    handle: { roles: ["administrator", "coordinator_csb", "coordinator_gsb"] },
  },
  {
    path: "details",
    Component: CommitteeSessionDetailsPage,
    handle: { roles: ["coordinator_csb", "coordinator_gsb"] },
  },
  { path: "number-of-voters", Component: NumberOfVotersPage, handle: { roles: ["administrator", "coordinator_gsb"] } },
  {
    path: "certificate",
    Component: ElectionCertificatePage,
    handle: { roles: ["administrator"] },
  },
  {
    path: "sub-committees",
    children: [
      {
        index: true,
        Component: SubCommitteeKeysOverviewPage,
        handle: { roles: ["administrator"] },
      },
      {
        path: ":subCommitteeId",
        Component: SubCommitteeKeysDetailPage,
        handle: { roles: ["administrator"] },
      },
    ],
  },
  {
    path: "report",
    children: [
      {
        index: true,
        Component: FinishDataEntryPage,
        handle: { roles: ["coordinator_csb", "coordinator_gsb"] },
      },
      {
        path: "committee-session/:committeeSessionId/download",
        children: [
          {
            index: true,
            element: __API_MSW__ ? (
              <NotAvailableInMock title={`${t("election.title.finish_data_entry")} - Abacus`} />
            ) : (
              <ElectionReportPage />
            ),
            handle: { roles: ["coordinator_csb", "coordinator_gsb"] },
          },
        ],
      },
    ],
  },
];
